<div class="card-base">
    <div class="card-content-scan">
        <div class="card-container mat-elevation-z1">
            <div class="card-content">
                <medical-order-scann-control [medicalorderId]="medicalorderId"></medical-order-scann-control>
            </div>
            <div *ngIf="returnurl" class="card-footer margin-top-medium">
                <button color="primary" mat-flat-button (click)="finish()">Siguiente</button>
            </div>
        </div>
    </div>
</div>